module.exports = __webpack_public_path__ + "static/img/boron-2.edef30d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/boron-2.jpg
// module id = S7tH
// module chunks = 1